/*
* Created by qing on 2020/2/27 3:48 下午
* **/
import TableMember from "./TableMember"

export default {
  extends: TableMember,
  data() {
    return {
      hasMember: false,
      hasDep: true,
      hasExternal: false,
      hasLabel: false,
      hasRole: false,
      hasCurrent: false,
    }
  },
  methods: {
    selectedComplete(selected) {
      console.log('selected333', selected)
      let value = this.currentRow[this.current.dataId]
      value.member = selected.memberIds
      value.depart = selected.depIds
      value.external = selected.extIds
      value.externalTag = selected.labelIds
    }
  }
}